import React from "react";
import styles from "./WelcomeBanner.module.scss";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import { MdOutlineClose } from "react-icons/md";
import { useNavigate } from "react-router";
import { setBannerVisible } from "../../../../../redux/agencyDashboard/agencyDashboardSlice";
import { useDispatch } from "react-redux";

function WelcomeBanner() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleInviteClick = () => {
    navigate("/Settings?popup=true");
  };

  const handleContactClick = () => {
    window.open("https://wa.me/+919892941618", "_blank");
  };
  return (
    <div className={styles.bannerContainer}>
      <div className={styles.bannerContent}>
        <div className={styles.welcomeText}>Welcome to Merito!</div>
        <div className={styles.welcomeParagraph}>
          Track sales, ad performance and growth of all your brands in one
          place.
        </div>
        <div className={styles.getStartedButton}>
          <MeritoButton type="primary-1" size="md" onClick={handleInviteClick}>
            Invite Brand
          </MeritoButton>
          <MeritoButton
            type="secondary-1"
            size="md"
            onClick={handleContactClick}
          >
            Contact Merito
          </MeritoButton>
        </div>
      </div>
      <img
        className={styles.welcomeBannerImage}
        src="/WelcomeBannerImage.png"
      />
      <div className={styles.closeButton}>
        <MeritoButton
          type="tertiary"
          size="md"
          onClick={() => dispatch(setBannerVisible(false))}
          aria-label="Close"
          extraStyles={{ padding: "0.5rem" }}
        >
          <MdOutlineClose />
        </MeritoButton>
      </div>
    </div>
  );
}

export default WelcomeBanner;
